interface SectionProps {
  title: string;
  icon: any;
  children: React.ReactNode;
}

const ConfigSection = ({ title, icon: Icon, children }: SectionProps) => (
  <div className="rounded-xl border border-border bg-gradient-card shadow-card p-5">
    <h2 className="font-display font-semibold flex items-center gap-2 mb-4">
      <Icon className="h-5 w-5 text-primary" />
      {title}
    </h2>
    <div className="space-y-4">{children}</div>
  </div>
);

export default ConfigSection;
export const inputClass = "h-11 bg-card border-border";
